import requests from '../requests/requests';

export default {
  'GET_SETTINGS': async ({commit}, {isLive, isValueBet}) => {
    try {
      const rs =
          await requests.settingsRequests.getSettings(isLive, isValueBet);
      commit('UPDATE_SETTINGS', rs);
      return rs;
    } catch (e) {
      console.log(e, ' error')
    }
  },
  'GET_USER_DATA': async ({commit}) => {
    try {
      const response = await requests.settingsRequests.getUserData();
      commit('UPDATE_USER_DATA', response);
      return response;
    } catch (e) {
      console.log(e, ' error')
    }
  },
  'GET_USER_BOOKMAKERS': async ({commit}, params) => {
    try {
      const response = await requests.settingsRequests.getUserBookmakers(params);
      commit('SET_USER_BOOKMAKERS', response);
      return response;
    } catch (e) {
      console.log(e, ' error')
    }
  },
  'GET_DIRECTORIES': async ({commit}, payload) => {
    try {
      const response = await requests.settingsRequests.getDirectories(payload);
      commit('UPDATE_DIRECTORIES', response);
      return response;
    } catch (e) {
      console.log(e, ' error')
    }
  },
  'GET_CURRENCIES': async ({commit}, payload) => {
    const response = await requests.settingsRequests.getCurrencies(payload);
    commit('UPDATE_CURRENCIES_LIST', response);
    return response;
  },
  'PUT_ZOOM_TO_SERVER': async (state, payload) => {
    return await requests.settingsRequests.putZoomToServer(payload);
  },
  'GET_COUNTRIES_LIST': async ({commit}, payload) => {
    const response = await requests.settingsRequests.getCountriesList(payload);
    commit('UPDATE_COUNTRIES_LIST', response);
    return response;
  },
  'GET_LEAGUES_LIST': async ({commit}) => {
    const response = await requests.settingsRequests.getLeaguesList();
    commit('UPDATE_LEAGUES_LIST', response);
    return response;
  },
  'SEND_POLL_ANSWER': async ({commit}, payload) => {
    return await requests.settingsRequests.sendPollAnswer(payload);
  },
  'KEEP_ALIVE': async () => {
    return await requests.settingsRequests.keepAlive();
  },
  'REFRESH_TOKEN': async (state, payload) => {
    try {
      const response = await requests.settingsRequests.refreshToken(payload);
      return response;
    } catch (err) {
      console.log(err, ' err');
    }
  },
  'SAVE_USER_SETTINGS': async (state, payload) => {
    return await requests.settingsRequests.setUserSettings(payload);
  },
  'UPDATE_ONBOARDING': async ({commit}, payload) => {
    const response = await requests.settingsRequests.getUserData();
    response.show_onboarding = true;
    commit('UPDATE_USER_DATA', response);
    return response;
  },
  'TOGGLE_STATUS_WIDGET_STATE'({commit}, payload) {
    commit('TOGGLE_STATUS_WIDGET_STATE', payload);
  },
  'SET_NEW_UNREAD_STATUS_STATE'({commit}, payload) {
    commit('SET_NEW_UNREAD_STATUS_STATE', payload);
  },
  'SET_NUMBER_OF_UNREAD_STATUS'({commit}, payload) {
    commit('SET_NUMBER_OF_UNREAD_STATUS', payload);
  },
  'SET_PREV_KOEF_FORMAT_STATE'({commit}, payload) {
    commit('SET_PREV_KOEF_FORMAT_STATE', payload);
  },
  'UPDATE_PERCENT_VALUE': ({ commit }, value) => {
    commit('SET_PERCENT_VALUE', value);
  },
};
